module.exports = __webpack_public_path__ + "images/d84978befadb755e65fb0182952ef0b29ca329d0bae235f1dd9bd62cf3b3096b.svg";